import DualButtonCTA, { ButtonVariant } from "components/ui/DualButtonCTA";
import { FadeIn } from "components/ui/FadeIn";

interface ButtonProps {
  buttonText: string;
  buttonUrl?: string;
  buttonVariant: ButtonVariant;
}

type BigTextProps = {
  bgColor?: string;
  button1?: ButtonProps;
  button2?: ButtonProps;
  miniTitle?: string;
  header: string;
  subHeader: string;
  titleTag: React.ElementType;
  textColor?: string;
  containerClassName?: string;
};

const BigText: React.FC<BigTextProps> = ({
  bgColor,
  miniTitle,
  header,
  subHeader,
  titleTag = "h1",
  button1,
  button2,
  textColor,
  containerClassName = ""
}) => {
  const TitleTag = titleTag;

  return (
    <>
      <section id="bigText-50" style={{ backgroundColor: bgColor, width: "100%" }}>
        <div className={`tile-container flex items-center align-middle scrollbar-hide ${containerClassName}`}>
          <div className="z-10 m-auto justify-center align-middle text-[inherit]">
            {miniTitle && (
              <span className="mb-4 inline-block text-2xs font-semibold uppercase text-[inherit]">{miniTitle}</span>
            )}
            <div className="tile-title-container">
              <TitleTag className="tile-main-header" style={{ color: textColor }}>
                {header}
              </TitleTag>
              <p className="tile-subtitle" style={{ color: textColor }}>
                {subHeader}
              </p>

              {(button1 || button2) && (
                <FadeIn>
                  <DualButtonCTA button1={button1} button2={button2} />
                </FadeIn>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BigText;
